import { useEffect, useState } from 'react'
import QrCode from '../qr/QrCode'
import { cambiarAccesoPortal, obtenerEstadoCredencial, regenerarQrSocio } from '../../services/socioPortalService'

function Modal({ title, children, onClose }) {
  return (
    <div className="fixed inset-0 z-[80] grid place-items-center overflow-y-auto bg-slate-950/60 px-3 py-safe-page backdrop-blur-sm sm:px-4" onMouseDown={onClose}>
      <section className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl sm:p-6" role="dialog" aria-modal="true" aria-label={title} onMouseDown={(event) => event.stopPropagation()}>
        <h3 className="text-xl font-bold">{title}</h3>
        {children}
        <button type="button" onClick={onClose} className="mt-5 min-h-12 w-full rounded-xl border border-border px-4 py-3 font-semibold text-primary">Cerrar</button>
      </section>
    </div>
  )
}

export default function SocioCredentialSection({ organizacionId, socioId, socioEstado, nombre }) {
  const [credential, setCredential] = useState(null)
  const [expanded, setExpanded] = useState(false)
  const [busy, setBusy] = useState('')
  const [error, setError] = useState('')
  const validationUrl = credential?.qr?.token ? window.location.origin + '/validar-socio/' + credential.qr.token : ''

  useEffect(() => {
    let active = true
    obtenerEstadoCredencial(organizacionId, socioId)
      .then((result) => { if (active) setCredential(result) })
      .catch((loadError) => { if (active) setError(loadError.message) })
    return () => { active = false }
  }, [organizacionId, socioId])

  async function togglePortalAccess() {
    const enable = !credential.portal.habilitado
    const message = enable
      ? '¿Habilitar el acceso al portal para este socio?'
      : 'El socio no podrá ingresar al portal y sus sesiones abiertas se cerrarán. ¿Deseas continuar?'
    if (!window.confirm(message)) return
    setBusy('portal'); setError('')
    try {
      const result = await cambiarAccesoPortal(organizacionId, socioId, enable)
      setCredential((current) => ({ ...current, portal: result.portal }))
    } catch (actionError) { setError(actionError.message) } finally { setBusy('') }
  }

  async function regenerateQr() {
    if (!window.confirm('El código QR anterior dejará de funcionar inmediatamente. ¿Deseas continuar?')) return
    setBusy('qr'); setError('')
    try {
      const result = await regenerarQrSocio(organizacionId, socioId)
      setCredential((current) => ({ ...current, qr: result.qr }))
    } catch (actionError) { setError(actionError.message) } finally { setBusy('') }
  }

  const portalLabel = !credential ? 'Cargando…' : credential.portal.habilitado ? 'Habilitado' : 'Bloqueado'

  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <section className="rounded-2xl border border-border bg-surface p-5 shadow-sm sm:p-6">
        <p className="text-xs font-bold uppercase tracking-widest text-primary">Credencial digital</p>
        <h3 className="mt-2 break-words text-xl font-semibold">{nombre}</h3>
        <div className="mt-5 flex flex-col items-center">
          {validationUrl ? <QrCode value={validationUrl} size={220} className="rounded-2xl border border-border" /> : <p className="py-12 text-sm text-text-secondary">Cargando código QR…</p>}
          <p className={'mt-4 rounded-full px-3 py-1 text-sm font-bold ' + (socioEstado === 'activo' ? 'bg-success/10 text-success-text' : 'bg-danger/10 text-danger')}>{socioEstado === 'activo' ? 'SOCIO ACTIVO' : 'SOCIO INACTIVO'}</p>
          <p className="mt-2 text-sm text-text-secondary">{credential?.qr?.activo ? 'Código válido' : 'Código inválido'}</p>
        </div>
        <div className="mt-5 grid gap-2 sm:grid-cols-2">
          <button type="button" disabled={!validationUrl} onClick={() => setExpanded(true)} className="min-h-11 rounded-xl border border-secondary px-4 py-2.5 font-semibold text-primary disabled:opacity-50">Ampliar QR</button>
          <button type="button" disabled={busy === 'qr'} onClick={regenerateQr} className="min-h-11 rounded-xl bg-primary px-4 py-2.5 font-semibold text-white disabled:opacity-50">{busy === 'qr' ? 'Regenerando…' : 'Regenerar QR'}</button>
        </div>
      </section>
      <section className="rounded-2xl border border-border bg-surface p-5 shadow-sm sm:p-6">
        <p className="text-xs font-bold uppercase tracking-widest text-primary">Acceso al portal</p>
        <h3 className="mt-2 text-xl font-semibold">{portalLabel}</h3>
        <p className="mt-2 text-sm text-text-secondary">El socio ingresa con su RUT. No se generan ni se almacenan contraseñas para el portal.</p>
        {credential?.portal?.bloqueado_hasta && <p className="mt-3 rounded-xl bg-danger/5 p-3 text-sm text-danger">Bloqueado temporalmente por intentos fallidos.</p>}
        <button type="button" onClick={togglePortalAccess} disabled={!credential || busy === 'portal'} className={'mt-6 w-full rounded-xl px-4 py-3 font-semibold disabled:opacity-50 ' + (credential?.portal?.habilitado ? 'border border-danger/40 text-danger hover:bg-danger/5' : 'bg-primary text-white')}>{busy === 'portal' ? 'Guardando…' : credential?.portal?.habilitado ? 'Bloquear acceso al portal' : 'Habilitar acceso al portal'}</button>
      </section>
      {error && <div className="lg:col-span-2 rounded-xl border border-danger/25 bg-danger/5 p-4 text-sm text-danger">{error}</div>}
      {expanded && validationUrl && <Modal title="Credencial digital CSPAH" onClose={() => setExpanded(false)}><div className="mt-5 flex justify-center"><QrCode value={validationUrl} size={300} className="w-full rounded-2xl" /></div><p className="mt-4 text-center font-semibold">{nombre}</p></Modal>}
    </div>
  )
}